import React from 'react';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';

export default function PlusMinus({ label, value, onChange, min = 0, max = 999, size = 'medium', color = 'primary', disabled = false }) {
  const iconSize = size === 'large' ? 48 : size === 'small' ? 32 : 40;
  const fontSize = size === 'large' ? '1.8rem' : size === 'small' ? '1rem' : '1.4rem';

  const handleDecrement = () => {
    if (value > min) onChange(value - 1);
  };

  const handleIncrement = () => {
    if (value < max) onChange(value + 1);
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
      {label && (
        <Typography variant="caption" color="text.secondary" sx={{ mb: 0.5, fontWeight: 600 }}>
          {label}
        </Typography>
      )}
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
        <IconButton
          onClick={handleDecrement}
          disabled={disabled || value <= min}
          color={color}
          sx={{
            width: iconSize,
            height: iconSize,
            border: '1px solid',
            borderColor: 'divider',
            borderRadius: 1,
            '&:active': { bgcolor: 'action.selected' },
          }}
        >
          <RemoveIcon />
        </IconButton>
        <Typography
          sx={{
            minWidth: iconSize,
            textAlign: 'center',
            fontSize,
            fontWeight: 700,
            userSelect: 'none',
          }}
        >
          {value}
        </Typography>
        <IconButton
          onClick={handleIncrement}
          disabled={disabled || value >= max}
          color={color}
          sx={{
            width: iconSize,
            height: iconSize,
            border: '1px solid',
            borderColor: 'divider',
            borderRadius: 1,
            '&:active': { bgcolor: 'action.selected' },
          }}
        >
          <AddIcon />
        </IconButton>
      </Box>
    </Box>
  );
}
